import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { navigateToUriInNewTab } from 'Helpers/Navigation';

const InvitationLinkPicker = ({
  resource,
}) => {
  return pick(resource, {
    [fr.relationships.invitationLink.name]: (
      <FDPrimaryActionButton
        onClick={(e) => navigateToUriInNewTab(e, resource?.relationship(fr.relationships.invitationLink.name)?.link('related').url(), 'noopener')}
        label={resource?.relationship(fr.relationships.invitationLink.name)?.meta('prompt') || 'Go to Wealth.com'}
      />
    ),
  }, null);
};

InvitationLinkPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

InvitationLinkPicker.defaultProps = {};

export default InvitationLinkPicker;
